import React from 'react';
import { cn } from '../../lib/utils';

const Sheet = React.forwardRef(({ className, open, onOpenChange, children, ...props }, ref) => {
    return (
        <div
            ref={ref}
            className={cn(
                'fixed inset-0 z-50',
                open ? 'block' : 'hidden',
                className
            )}
            {...props}
        >
            {children}
        </div>
    );
});
Sheet.displayName = 'Sheet';

const SheetContent = React.forwardRef(({ className, children, ...props }, ref) => {
    return (
        <div
            ref={ref}
            className={cn(
                'fixed right-0 top-0 h-full w-full border-l bg-background p-6 shadow-lg transition ease-in-out',
                className
            )}
            {...props}
        >
            {children}
        </div>
    );
});
SheetContent.displayName = 'SheetContent';

const SheetHeader = React.forwardRef(({ className, ...props }, ref) => {
    return (
        <div
            ref={ref}
            className={cn('flex flex-col space-y-1.5 text-center sm:text-left', className)}
            {...props}
        />
    );
});
SheetHeader.displayName = 'SheetHeader';

const SheetTitle = React.forwardRef(({ className, children, ...props }, ref) => {
    return (
        <h2
            ref={ref}
            className={cn('text-lg font-semibold text-foreground', className)}
            {...props}
        >
            {children}
        </h2>
    );
});
SheetTitle.displayName = 'SheetTitle';

const SheetDescription = React.forwardRef(({ className, ...props }, ref) => {
    return (
        <p
            ref={ref}
            className={cn('text-sm text-muted-foreground', className)}
            {...props}
        />
    );
});
SheetDescription.displayName = 'SheetDescription';

export { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription };
